import React from 'react';
import { Div } from 'components/Elements/Div/Div';
import { OverviewDetailInterface } from 'components/Overview/overview.types';
import RowDetail from 'components/Overview/RowDetails/RowDetail';

interface RowDetailsProps {
  rowDetails: OverviewDetailInterface[];
}

type Props = RowDetailsProps;

const RowDetails = ({ rowDetails }: Props) => {
  if (!rowDetails?.length) {
    return null;
  }

  return (
    <Div display='flex' width='100%' flexWrap='wrap'>
      {rowDetails.map((detail) => (
        <RowDetail key={detail.title} {...detail} />
      ))}
    </Div>
  );
};

export default RowDetails;
